<template>
  <div class="book-item2"  :title="item.bookName" @click="goDetail">
    <div class="item-pic">
      <img class="van-image" :src="item.cover_img" @error="imgError(item)" />
    </div>
    <div class="item-txt">
      <div class="item-title" :title="item.title">{{item.title}}</div>
      <div class="item-sub">
        <p v-if="item.pub_date"><span class="xx">出版时间：</span><em>{{item.pub_date}}</em></p>
        <p v-if="item.pub_house"><span class="xx">出版单位：</span><em>{{item.pub_house}}</em></p>
        <p v-if="item.author"><span class="xx" :title="item.author">责任者/责任方式：</span><em>{{item.author}}</em></p>
      </div>
    </div>
  </div>
</template>

<script> 
export default {
  name: 'BookItem2',
  props: { item:Object},
  data(){
    return{
       
    }
  },
methods:{
  goDetail(){
    let link = this.$router.resolve({
     path:'/book/'+this.item.id,
    })
    window.open(link.href,"_blank")
  }
},
}
</script>
<style scoped lang="scss">


</style>